import { FaStarOfLife, FaVideo } from "react-icons/fa";
import { LuAudioLines, LuImage } from "react-icons/lu";
import { FiBox } from "react-icons/fi";

const SIZE_CLASSES = {
  sm: {
    container: "p-1",
    icon: "w-2.5 h-2.5",
    generationMarker: "w-2 h-2",
    generationIcon: "w-1 h-1",
  },
  md: {
    container: "p-1.5",
    icon: "w-3 h-3",
    generationMarker: "w-2.5 h-2.5",
    generationIcon: "w-1.5 h-1.5",
  },
};

function MediaTypeIcon({ mediaType, scene3d, className }) {
  if (scene3d) {
    return <FiBox className={`${className} text-secondary-foreground`} />;
  }
  if (mediaType === "audio") {
    return (
      <LuAudioLines className={`${className} text-secondary-foreground`} />
    );
  }
  if (mediaType === "video") {
    return <FaVideo className={`${className} text-secondary-foreground`} />;
  }
  if (mediaType === "image") {
    return <LuImage className={`${className} text-secondary-foreground`} />;
  }
  return null;
}

export default function AssetMediaTypeBadge({ asset, size = "md" }) {
  if (!asset) return null;

  const sizeClasses = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div
      id="AssetMediaTypeBadge"
      className="AssetMediaTypeBadge absolute bottom-0 left-0 flex p-1 pointer-events-none">
      <div
        className={`${sizeClasses.container} flex items-center justify-center bg-card rounded-md border text-secondary-foreground/80 relative overflow-hidden`}>
        <MediaTypeIcon
          mediaType={asset.mediaType}
          scene3d={asset.scene3d}
          className={sizeClasses.icon}
        />
        {asset.source === "generation" && (
          <div
            className={`absolute top-0 left-0 bg-card rounded-full flex items-center justify-center ${sizeClasses.generationMarker}`}>
            <FaStarOfLife
              className={`${sizeClasses.generationIcon} text-secondary-foreground`}
            />
          </div>
        )}
      </div>
    </div>
  );
}
